import React from 'react';
import { preload } from 'react-dom';
import './Experience.css';
import Background from '../Images/work-background.webp';
import Kiwi from '../Images/KiwiCharge.jpg';
import GM from '../Images/GeneralMotors.jpg';
import Ottonomi from '../Images/Ottonomi-AI.png';
import ResearchAssistant from '../Images/Research-Assistant.png';
import RamadanRespite from '../Images/Ramadan-Respite.png';
import PLP from '../Images/PLP-Supervision.png';
import Resume from '../Images/Resume.pdf'
import { FaChevronDown } from 'react-icons/fa';

const Experience = () => {
  preload(Background, { as: 'image', fetchPriority: 'high' });
  const scrollToContent = () => {
    const section = document.getElementById("experience-section");
    section.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="home-container">
      {/* Top Section: Intro */}
      <div className="front-page" style={{ backgroundImage: `url(${Background})` }}>
      <div className="background-overlay"></div>
        <div className="overlay">
          <div className="overlay-content">
            <h1>Work Experience</h1>
            <h3>Mechatronics Engineer with a Fiery Passion for Robotics</h3>
            <a href={Resume} download="Omar_Elgazzar_Resume.pdf" className="resume-button">
              Download Resume
            </a>
            <button className="scroll-button" onClick={scrollToContent}>
              <FaChevronDown size={30} color="white" />
            </button>
          </div>
        </div>
      </div>

      {/* Work Experience Section */}
      <div id="experience-section" className="experience-wrapper">

        
        {/* Experience 6 */}
        <div className="experience-item reverse">
          <div className="experience-image">
            <img loading="lazy" fetchPriority="low" width="4032" height="3024" src={Kiwi} alt="KiwiCharge" />
          </div>
          <div className="experience-content">
            <h2>Mechatronics Engineer</h2>
            <p><em>KiwiCharge Inc. | May. 2026 - Aug. 2026</em></p>
            <ul>
              <li>Named inventor on a provisional patent filed for a robotic arm end-effector enabling autonomous wireless charging of 
                vehicles, refining the design through 6 engineering iterations to improve charging reliability</li>
              <li>Utilized SolidWorks to CAD-model the robot's internal chassis, integrating structural members, 16 electrical components, 
                and outer shell interfaces, all with design-for-manufacturability in mind</li>
              <li>Validated chassis structural performance through SolidWorks Simulation and Ansys FEA, optimizing load paths and reducing 
                overall weight by 17% relative to initial prototype</li>
              <li>Fabricated and wired a 378V high-voltage battery pack using 120 BYD cells, integrating bus bars, insulation, a BMS, and 
                an Ampernext charge controller while validating electrical safety and reliability</li>
            </ul>
          </div>
        </div>
        <hr className="experience-divider" />
        
        
        {/* Experience 5 */}
        <div className="experience-item reverse">
          <div className="experience-image">
            <img loading="lazy" fetchPriority="low" width="3024" height="4032" src={GM} alt="GM" />
          </div>
          <div className="experience-content">
            <h2>Manufacturing Engineer</h2>
            <p><em>General Motors | Sept. 2025 - Dec. 2025</em></p>
            <ul>
              <li>Led the design of a NX-based robotic adhesive application system for vehicle parts packaging, reallocating 15 employees, 
                reducing annual labor costs by $1.53M and driving a 4x increase in throughput</li>
              <li>Engineered an NX-based blast shack to remove ELPO buildup from E-frames, restoring conductivity and cutting scrap-related 
                costs against a projected $1.3M annual baseline identified in the initial business case</li>
              <li>Implemented a COBO Vision camera-based defect detection system along the production line, utilizing YOLOv12 to identify 1 
                in 18 defective parts and minimizing rework</li>
              <li>Developed new AutoCAD layouts for FANUC robotic arm welding cells, enhancing automation efficiency and production throughput of vehicle doors</li>
            </ul>
          </div>
        </div>
        <hr className="experience-divider" />

        {/* Experience 4 */}
        <div className="experience-item">
          <div className="experience-image">
            <img loading="lazy" fetchPriority="low" width="3024" height="4032" src={Ottonomi} alt="Ottonomi AI" />
          </div>
          <div className="experience-content">
            <h2>AI Software Engineer</h2>
            <p><em>Ottonomi AI | Jan. 2025 - May. 2025</em></p>
            <ul>
              <li></li>
              <li>Developed a PyTorch-based vehicle detection pipeline for severe weather, improving mAP50-95 by 112% over baseline 
                pretrained YOLO models</li>
              <li>Automated analysis of frequent vehicle-stop zones using Python, achieving 90% detection accuracy</li>
              <li>Containerized ML workflows using Docker, enabling product delivery that helped secure $200K in revenue</li>
            </ul>
          </div>
        </div>
        <hr className="experience-divider" />

        {/* Experience 3 */}
        <div className="experience-item reverse">
          <div className="experience-image">
            <img loading="lazy" fetchPriority="low" width="4032" height="3024" src={ResearchAssistant} alt="Mechanical Research Assistant" />
          </div>
          <div className="experience-content">
            <h2>Research Assistant</h2>
            <p><em>Ontario Tech University | Jan. 2025 - May. 2025</em></p>
            <ul>
              <li>Researched and applied vortex-induced vibration mitigation techniques from 60+ research papers</li>
              <li>Designed 20+ bluff-body geometries in SolidWorks to simulate and optimize active flow control strategies</li>
              <li>Constructed experimental test rigs to evaluate bluff-body cylinders, measuring performance of active and
              passive flow control techniques under controlled wind-tunnel conditions</li>
              <li>Troubleshot and fixed faulty computers and lab equipment</li>
            </ul>
          </div>
        </div>
        <hr className="experience-divider" />

        {/* Experience 2 */}
        <div className="experience-item">
          <div className="experience-image">
            <img loading="lazy" fetchPriority="low" width="1600" height="1200" src={RamadanRespite} alt="Ramadan Respite" />
          </div>
          <div className="experience-content">
            <h2>Founder / CEO</h2>
            <p><em>Ramadan Respite | May. 2023 - Present</em></p>
            <ul>
              <li>Founded a registered non-profit organization combating food insecurity through private meal/grocery delivery</li>
              <li>Organized volunteers to cook halal meals and deliver them discreetly to beneficiaries</li>
              <li>The program helps 500+ individuals annually across the GTA</li>
            </ul>
          </div>
        </div>
        <hr className="experience-divider" />

        {/* Experience 1 */}
        <div className="experience-item reverse">
          <div className="experience-image">
            <img loading="lazy" fetchPriority="low" width="4032" height="3024" src={PLP} alt="PLP Student Supervisor" />
          </div>
          <div className="experience-content">
            <h2>PLP Student Supervisor</h2>
            <p><em>Durham District School Board | Dec. 2022 - July 2024</em></p>
            <ul>
              <li>Mentored students with mental and physical disabilities in STEM subjects</li>
              <li>Engaged in social activities with students, including outings to movies and parks</li>
              <li>Supported student integration with staff and peers to improve communication and social skills</li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Experience;
